export default function convertBase64 (file, functionOnLoad = defaultFunctionOnLoad) {
  return new Promise((resolve, reject) => {
    let base64 = new FileReader();
    base64.readAsDataURL(file);
    base64.onload = functionOnLoad(base64, resolve, reject);
  })
}

const defaultFunctionOnLoad = (base64, resolve, reject) => () => {
  if(base64.result) {
    resolve(base64.result.split(',')[1]);
  } else {
    reject(base64);
  }
}